<app-title mat-dialog-title></app-title>
<app-login-form mat-dialog-content [loginForm]="loginForm"></app-login-form>
<app-login-actions mat-dialog-actions (onSubmit)="onSubmit($event)" (onCancel)="cancel()"></app-login-actions>